import { Component, Input } from '@angular/core';
import { LoggerService, LogCategory, LogType, LogCoreComponent } from 'src/app/core/services/logger.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeactivateGuardService } from '../../services/deactivate-guard.service';
import { ProfileService } from '../../services/profile.service';

@Component({
    selector: 'save-changes-modal',
    templateUrl: './save-changes-modal.component.html',
    styleUrls: ['./save-changes-modal.component.scss'],
    standalone: false
})
export class SaveChangesModalComponent {

    @Input() section: any;
    @Input() buttonType: any;

    constructor(
        private logger: LoggerService,
        public activeModal: NgbActiveModal,
        private deactivateService: DeactivateGuardService,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.ModalSave, category);
    }

    public navigateAway(choice: boolean) {        
        this.deactivateService.navigateAwaySelection$.next(choice);
        this.activeModal.close();
    }
}
